import { Box, Flex, Img, Text } from '@chaine/keychaine';
import * as React from 'react';
export const Quotee = (props) => {
    const { name, jobTitle, imageSrc, companyLogo, ...boxProps } = props;
    return (React.createElement(Box, { ...boxProps },
        React.createElement(Img, { src: imageSrc, mx: "auto", objectFit: "cover", w: "16", h: "16", rounded: "full" }),
        React.createElement(Box, { mt: "3" },
            React.createElement(Text, { as: "cite", fontStyle: "normal", fontWeight: "bold" }, name),
            React.createElement(Text, { fontSize: "sm", color: "gray.500" }, jobTitle),
            React.createElement(Flex, { alignItems: "center", alignContent: "center", justifyContent: "center", justifyItems: "center" },
                React.createElement(Img, { src: companyLogo, maxWidth: "32", maxHeight: "10", height: "auto", fill: "none", color: "gray.400", position: "relative", objectFit: "cover", mt: 6 })))));
};
